import React, { useRef } from "react";
import "../../assets/styles/local/member.css";
import "../../assets/styles/local/MyTaskToday.css";
import {
  Image,
  Container,
  Row,
  Col,
  Card,
  ListGroup,
  Badge,
} from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import smaliIcon from "../../assets/icons/meh.svg";
import CircleWaves from "../../assets/gif/circle-waves.gif";
import Congratulations from "../../assets/gif/congratulations.gif";
import { useDispatch, useSelector } from "react-redux";
import { API_URL, UPDATE_CONTACTS } from "../../redux/constants/type";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import {
  fetchMyFacebook,
  fetchTranslationData,
  myTaskToday,
  AddComments,
} from "../../redux/actions/action";
import {
  globalChat,
  addIndividualGroups,
} from "../../redux/actions/chatActions";
import ContactTaskModal from "../../pages/dynamic/ContactTaskModal";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import moment from "moment";
import AssigneeIcon from "../../assets/icons/Assignee icon.svg";
import chatnoty from "../../assets/icons/chatnotyicon.svg";
import phoneicon from "../../assets/icons/phoneicon.svg";
import smsicon from "../../assets/icons/smsicon.svg";
import gifticon from "../../assets/icons/gifticon.svg";
import chat from "../../assets/icons/chat.svg";
import search from "../../assets/icons/search.svg";
import greensms from "../../assets/icons/Greenchat.svg";
import duc from "../../assets/images/duc5.jpg";
import Header from "../../layouts/Header";
import Loader from "../Dailogs/Loader";
import { useEffect } from "react";
import { useState } from "react";
// import Sidebar from "../pages/static/en/Sidebar";
import { useHistory } from "react-router-dom";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
// import MvpView from "../pages/dynamic/MvpView"
import PhoneInput from "react-phone-input-2";
import MyPersonalTodoTask3 from "./MyPersonalTodoTask3";

const Member = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const initialRender = React.useRef(true);

  const primaryColor = window.localStorage.getItem("primarycolor");
  const FetchMyFacebook = useSelector((state) => state.user.fetchMyFacebook);
  const taskToday = useSelector((state) => state.user.taskToday);
  const FetchCompanyDetails1 = useSelector(
    (state) => state.user.FetchCompanyDetails,
  );
  const [showModal, setShowModal] = useState(false);
  const [from, setFrom] = useState(moment().toDate());
  const [modalFunctionNoty, setModalFunctionNoty] = useState("");
  const [show, setShow] = useState([]);
  const [modalFunction, setModalFunction] = useState("");
  const [taskid, setTaskid] = useState("");
  const [searchText, setSearchText] = useState("");
  const TaskId = window.localStorage.getItem("taskid");
  const [comments, setComments] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [length, setLength] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [message, setMessage] = useState("");
  const [minComments, setMinComments] = useState([]);
  const [fetchMyFacebooklist, setFetchMyFacebooklist] = useState([]);
  const [FetchCompanyThemRes, setFetchCompanyThemRes] = useState([]);
  const [compenylLogo, setCompenylLogo] = useState("");
  const [textclr, setTextclr] = useState("");
  const [secondclr, setSecondclr] = useState("");
  const [background, setBackground] = useState("");
  const [query, setQuery] = useState("");
  const [fulLenghtEmail, setFulLenghtEmail] = useState(false);
  const [fetchTransFaceBookList, setFetchTransFaceBookList] = useState({});
  const t = (key) => fetchTransFaceBookList?.[key] || "";
  const [emailI, setEmailI] = useState();
  const userid = window.localStorage.getItem("userid");
  const [showLoader, setShowLoader] = useState(true);
  const [canGoBack, setCanGoBack] = useState(false);

  // const todaydate = moment().format("Do MMMM");
  const todaydate = moment().format("DD/MM/YYYY");

  useEffect(() => {
    dispatch(fetchMyFacebook(userid));
    fetchScreenTranslations("TeamConnect").then((res) => {
      setFetchTransFaceBookList(res);
    });
  }, []);

  React.useEffect(() => {
    if (!initialRender.current) {
      if (FetchMyFacebook != null) {
        if (FetchMyFacebook.status == true) {
          setFetchMyFacebooklist(FetchMyFacebook?.data);
          setTimeout(() => {
            setShowLoader(false);
          }, 1000);
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [FetchMyFacebook]);

  useEffect(() => {
    if (FetchCompanyDetails1 != null) {
      if (FetchCompanyDetails1.status == true) {
        setFetchCompanyThemRes(FetchCompanyDetails1.data);
        setCompenylLogo(FetchCompanyDetails1.data[0]?.companylogo);
        setTextclr(FetchCompanyDetails1.data[0]?.textcolor);
        setSecondclr(FetchCompanyDetails1.data[0]?.secondarycolor);
        setBackground(FetchCompanyDetails1.data[0]?.backgroundcolor);
      } else {
      }
    }
  }, [FetchCompanyDetails1]);

  ///////////////// My task today api start //////////////
  const [task, setTask] = useState();
  useEffect(() => {
    dispatch(myTaskToday(userid));
  }, []);

  useEffect(() => {
    if (!initialRender.current) {
      if (taskToday != null) {
        if (taskToday.status == true) {
          setTask(taskToday?.data);
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [taskToday]);
  ///////////////// My task today api end //////////////

  const handleFileChange2 = (e) => {
    const target = e.target.files[0];
    let formData = new FormData();
    formData.append("file", target);

    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response !== null) {
          setImgUrl(response.data[0]);
          // setAttachMessage(target.name + " " + "File is Attached in comment box");
          // setShowError(true);
        } else {
        }
      })
      .catch(function (error) {});
    // alert(target.name + " " + "File is Attached in comment box");
  };

  const fetchComments2 = async (taskId) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        relatedtoid: taskId,
        type: "task",
      },
    }).then((response) => {
      setComments(response.data);
    });
  };

  const handleAddComments2 = () => {
    if (!message) {
      return;
    }
    dispatch(AddComments(userid, taskid, message, "task", imgUrl));
    setTimeout(() => {
      window.location.reload();
      fetchComments(taskid);
    }, 1000);
    setMessage("");
    setImgUrl("");
  };

  const backgroundbirthday = {
    // width: "334px",
    backgroundRepeat: "no-repeat",
    // backgroundAttachment: 'scroll',
    // backgroundPosition: "-40px -50px",
    // backgroundSize: "260px",
    backgroundPosition: "50% 60%",
    backgroundSize: "122%",
    // width: "80%",
    // height: "200px",
    // width: "clamp(160px, 9.021vw, 9.021vw)",
    // height: "clamp(165px, 9.021vw, 9.021vw)",
    backgroundImage: `url(${CircleWaves})`,
  };
  const back = {
    backgroundcolor: background,
    // width:"229px"
  };
  const textcolors = {
    color: textclr,
  };
  const backgroundStyle = {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    // width: "80%",
    // height: "200px",
    backgroundImage: `url(${Congratulations})`,
  };

  // ASC for Update task modal start.
  const textAreaRef = useRef("");
  const inputFile = React.useRef(null);
  // const TaskId = window.localStorage.getItem("taskid");
  const userId = window.localStorage.getItem("userid");
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  const [modelTypeId, setModelTypeId] = useState("");
  const [attachMessage, setAttachMessage] = useState("");
  const onButtonClick = () => {
    inputFile.current.click();
  };
  // const [taskid, setTaskid] = useState("");
  const [contactname3, setContactname3] = useState(false);
  // const [comments, setComments] = useState([]);
  // const [maxComments, setMaxComments] = useState([]);
  const [taggedUser, setTaggedUser] = useState([]);
  // const [minComments, setMinComments] = useState([]);
  const [val, setVal] = useState("");
  const [popups, setPopups] = useState(false);
  // const [show, setShow] = useState([]);
  const initialRender5 = React.useRef(true);
  const [addTaskModal, setAddTaskModal] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [showNewTaskSystem, setShowNewTaskSystem] = useState(false);
  const [isBasicMember, setIsBasicMember] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const [statusName, setStatusName] = useState("");
  const [reRenderAPI, setReRenderAPI] = useState(false);
  const [finalContact, setFinalContact] = useState("");
  // const [enablecomm, setEnableComm] = useState(false);
  // const [showcmnt, setShowcmnt] = useState(true);
  // const [message, setMessage] = useState("");
  // const [length, setLength] = useState("");
  // const [imgUrl, setImgUrl] = useState("");

  const handleFileChange = (data) => {
    setImgUrl(data.link);
    setAttachMessage(`${data.name} File is Attached in comment box`);
  };

  useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          setShow(comments.data);
          setLength(comments.data.length);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);

  const fetchComments = async (taskId) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        relatedtoid: taskId,
        type: "task",
      },
    }).then((response) => {
      setComments(response.data);
    });
  };

  useEffect(() => {
    if (taskid) {
      fetchComments(taskid);
    }
  }, [taskid]);

  useEffect(() => {
    if (TaskId) {
      // setReRenderAPI(true);
      // setShowModal(true);
      setTaskid(TaskId);
      // setModalFunctionNoty("Notification");
      // setModalFunction("Notification");
    }
    setTimeout(() => {
      window.localStorage.removeItem("taskid");
    }, 5000);

    return () => {
      window.localStorage.removeItem("taskid");
    };
  }, []);

  const handleAddComments = (attachmentUrl) => {
    // dispatch(AddComments(userId, taskid, message, "task", imgUrl, taggedUser));
    dispatch(
      AddComments(userId, taskid, val, "task", attachmentUrl, taggedUser),
    );

    setTimeout(() => {
      fetchComments(taskid);
    }, 1000);
    setTaggedUser([]);
    setMessage("");
    setVal("");
    setImgUrl("");
  };
  // ASC for Update task modal end.

  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div
            style={{
              color: "#333333",
              fontSize: "16px",
              lineHeight: "27px",
              fontWeight: "bold",
              display: "flex",
              columnGap: "26px",
              alignItems: "center",
            }}
          >
            {t("TeamConnect")}
          </div>
        }
      />

      {/* <ContactTaskModal
        showModal={showModal}
        modalFunctionNoty={modalFunctionNoty}
        taskid={taskid}
        setTaskid={setTaskid}
        setShowModal={(show, reload) => {
          setShowModal(false);
          window.localStorage.removeItem("taskid");
          window.location.reload();
        }}
        setComments={setComments}
        modalFunction={modalFunction}
        setEnableComm={setEnableComm}
        setShowcmnt={setShowcmnt}
        enablecomm={enablecomm}
        showcmnt={showcmnt}
        setMessage={setMessage}
        message={message}
        // onButtonClick={onButtonClick}
        handleFileChange={handleFileChange}
        handleAddComments={handleAddComments}
        maxComments={maxComments}
        show={show}
        length={length}
        setLength={setLength}
        setShow={setShow}
        imgUrl={imgUrl}
        setImgUrl={setImgUrl}
        setMaxComments={setMaxComments}
        from={from}
        searchText={searchText}
      /> */}

      <AddTaskModal
        isBasicMember={isBasicMember}
        isBuildingBlock={isBuildingBlock}
        val={val}
        setVal={setVal}
        textAreaRef={textAreaRef}
        modelTypeId={modelTypeId}
        showModal={showModal}
        modalFunctionNoty={modalFunctionNoty}
        taskid={taskid}
        popups={popups}
        setPopups={setPopups}
        setTaskid={setTaskid}
        setShowModal={(show, reload) => {
          setShowModal(false);
          setModelTypeId("");
          window.localStorage.removeItem("taskid");
          // fetchTasksBasedOnFilter(
          //   searchText,
          //   startDate,
          //   endDate,
          //   filterPayload
          // );
          history.push(`/teamconnect`);
        }}
        setComments={setComments}
        modalFunction={modalFunction}
        setModalFunction={setModalFunction}
        setEnableComm={setEnableComm}
        setShowcmnt={setShowcmnt}
        enablecomm={enablecomm}
        showcmnt={showcmnt}
        setMessage={setMessage}
        message={message}
        onButtonClick={onButtonClick}
        handleFileChange={handleFileChange}
        handleAddComments={handleAddComments}
        maxComments={maxComments}
        taggedUser={taggedUser}
        setTaggedUser={setTaggedUser}
        show={show}
        length={length}
        setLength={setLength}
        setShow={setShow}
        attachmentUrl={imgUrl}
        setAttachmentUrl={setImgUrl}
        setMaxComments={setMaxComments}
        from={from}
        searchText={searchText}
        setReRenderAPI={setReRenderAPI}
        statusList={statusList}
        statusName={statusName}
        showNewTaskSystem={showNewTaskSystem}
      />

      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div className="parent">
          <searchSection>
            {" "}
            {/* search for mobile view */}
            <div className="member_searchShow" style={{ position: "relative" }}>
              <input
                className="member_search_input_input"
                type="text"
                placeholder=""
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
              <img className="member_search_input_icon" src={search} alt="" />
            </div>
          </searchSection>
          <div className="outer my-3">
            <div className="row myTaskCard_Grid ms-xxl-0 ms-xl-0 ms-lg-0 ms-md-0 ms-sm-1 ms-4">
              <Col lg={12} md={12} sm={12} xs={12} className="">
                <Row className="me-lg-5 me-xl-3 gap-md-5 gap-lg-0 gap-xl-0">
                  {fetchMyFacebooklist?.filter(
                    (data) =>
                      data?.firstname
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()) ||
                      data?.lastname
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()) ||
                      data?.jobpost
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()) ||
                      data?.email
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()) ||
                      data?.phonenumber
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()) ||
                      moment(data?.dateofbirth)
                        .format("DD/MM/YYYY")
                        ?.toLowerCase()
                        .includes(query?.toLowerCase()),
                  )?.length ? (
                    fetchMyFacebooklist
                      ?.filter(
                        (data) =>
                          data?.firstname
                            ?.toLowerCase()
                            .includes(query?.toLowerCase()) ||
                          data?.lastname
                            ?.toLowerCase()
                            .includes(query?.toLowerCase()) ||
                          data?.jobpost
                            ?.toLowerCase()
                            .includes(query?.toLowerCase()) ||
                          data?.email
                            ?.toLowerCase()
                            .includes(query?.toLowerCase()) ||
                          data?.phonenumber
                            ?.toLowerCase()
                            .includes(query?.toLowerCase()) ||
                          moment(data?.dateofbirth)
                            .format("DD/MM/YYYY")
                            ?.toLowerCase()
                            .includes(query?.toLowerCase()),
                      )
                      .map((data, index) => {
                        let day = todaydate.split("/")[0];
                        let month = todaydate.split("/")[1];
                        let todaymain = `${day}/${month}`;
                        return (
                          <>
                            <Col
                              xl={4}
                              lg={6}
                              md={5}
                              xxl={3}
                              sm={6}
                              xs={10}
                              className="my-5 card-height"
                            >
                              <Card
                                key={index}
                                className="text-center cardbody  ms-2"
                              >
                                <div
                                  className="profilediv backgroundbirthday2"
                                  // style={
                                  //   todaydate ===
                                  //     moment(data?.dateofbirth).format("Do MMMM")
                                  //     ? backgroundStyle
                                  //     : null
                                  // }

                                  style={
                                    todaymain ===
                                    moment(data?.birthDate).format("DD/MM")
                                      ? backgroundbirthday
                                      : back
                                  }
                                >
                                  {data?.imageurl !== "" ? (
                                    <Image
                                      variant="top"
                                      style={{ border: "6px solid white" }}
                                      // style={{
                                      //   border:
                                      //     " 6px solid" +
                                      //     data.companydetails[0].primarycolor,
                                      // }}
                                      className="teammemberphoto rounded-circle"
                                      // src={data?.imageurl}
                                      src={data?.imageurl}
                                    />
                                  ) : (
                                    <div
                                      className="teammemberphoto rounded-circle abreviation-circle"
                                      style={{ border: "6px solid white" }}
                                    >
                                      <p
                                        className=" pt-3"
                                        style={{
                                          fontSize: "32px",
                                          fontWeight: 800,
                                        }}
                                      >
                                        {/* {data?.lastname?.toUpperCase()
                                          ? data?.firstname
                                              .slice(0, 1)
                                              .toUpperCase() +
                                            " " +
                                            data?.lastname
                                              .slice(0, 1)
                                              .toUpperCase()
                                          : data?.firstname
                                              ?.slice(0, 1)
                                              .toUpperCase() +
                                            " " +
                                            data?.firstname
                                              ?.slice(1, 2)
                                              .toUpperCase()} */}

                                        {data?.initials}
                                      </p>
                                    </div>
                                  )}
                                </div>
                                <Card.Body
                                  className="ps-4 facebook-cards-discription"
                                  // style={{ padding: "10px 28px", height: "185px" }}
                                  // style={{ height: "200px" }}
                                >
                                  <Card.Title
                                    className="mb-0"
                                    // style={{ textcolors }}
                                    style={{ color: "#333333" }}

                                    // style={{
                                    //   color: data.companydetails[0].primarycolor,
                                    // }}
                                  >
                                    {/* {data?.firstname + " " + data?.lastname} */}
                                    {data?.lastname
                                      ? data?.firstname + " " + data?.lastname
                                      : data?.firstname}
                                  </Card.Title>

                                  <div className="mt-3">
                                    <Card.Subtitle
                                      style={{
                                        // textcolors,
                                        color: "#333333",
                                        fontWeight: "300",
                                        height: "1px",
                                      }}
                                      className="mb-2 "
                                    >
                                      {data?.jobpost}
                                    </Card.Subtitle>
                                    <div
                                      className="pt-4 cardli"
                                      style={{ textcolors }}
                                    >
                                      {data?.phonenumber && (
                                        <div className="d-flex align-items-baseline">
                                          <Image
                                            variant="top"
                                            className=""
                                            src={phoneicon}
                                            style={{
                                              width:
                                                "clamp(11px, .729vw, .729vw)",
                                              height:
                                                "clamp(15px, .99vw, .99vw)",
                                            }}
                                          />
                                          <li className=" ms-3 ">
                                            {/* +{data?.phonenumber} */}

                                            {data?.phonenumber !== "" ? (
                                              <PhoneInput
                                                containerClass={
                                                  "member-list-phone-number"
                                                }
                                                country={"nl"}
                                                enableSearch={true}
                                                value={data?.phonenumber}
                                                inputStyle={{
                                                  fontSize:
                                                    "clamp(12px, 0.729vw, 0.729vw)",
                                                  padding: 0,
                                                  fontWeight: 400,
                                                  width:
                                                    "-webkit-fill-available !important",
                                                  color: "#333333",
                                                  fontFamily:
                                                    "Manrope, Regular",
                                                }}
                                              />
                                            ) : (
                                              ""
                                            )}
                                          </li>
                                        </div>
                                      )}
                                      <div className="d-flex align-items-baseline">
                                        <Image
                                          variant="top"
                                          className=""
                                          src={smsicon}
                                          style={{
                                            width:
                                              "clamp(13px, .885vw, .885vw)",
                                            height:
                                              "clamp(11px, .729vw, .729vw)",
                                          }}
                                        />
                                        <li
                                          className=" mx-3"
                                          // style={{ width: "9.053vw" }}
                                        >
                                          <div
                                            className="asconMouseText mt-2"
                                            onMouseOver={() => {
                                              if (data?.email?.length > 30) {
                                                setFulLenghtEmail(true);
                                                setEmailI(index);
                                              }
                                            }}
                                            onMouseLeave={() => {
                                              setFulLenghtEmail(false);
                                              setEmailI("");
                                            }}
                                          >
                                            {data?.email.length > 30
                                              ? data?.email.slice(0, 30) + "..."
                                              : data?.email}
                                          </div>

                                          {fulLenghtEmail &&
                                            emailI === index && (
                                              <div className="email-hover-stat p-2">
                                                {data?.email}
                                              </div>
                                            )}
                                        </li>
                                      </div>

                                      {data?.dateofbirth && (
                                        <div className="d-flex align-items-baseline">
                                          {" "}
                                          <div>
                                            <Image
                                              variant="top"
                                              className=""
                                              src={gifticon}
                                              style={{
                                                width:
                                                  "clamp(13px, .885vw, .885vw)",
                                                height:
                                                  "clamp(14px, .938vw, .938vw)",
                                              }}
                                            />
                                          </div>
                                          <li className=" mx-3 pt-2">
                                            {moment(data?.dateofbirth).format(
                                              "DD/MM/YYYY",
                                            )}
                                          </li>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Card.Body>

                                <Card.Body
                                  className={
                                    data?.isactive == 1
                                      ? "cardfooter text-center py-2 ps-0 person-active"
                                      : "cardfooter text-center py-2 ps-0"
                                  }
                                >
                                  <Card.Link
                                  // href="#"
                                  // style={{ marginRight: "10%" }}
                                  >
                                    {" "}
                                    {data?.isactive == 1 ? (
                                      <Image
                                        src={chat}
                                        className="my-2"
                                        style={{
                                          width:
                                            "clamp(16px, 1.094vw, 1.094vw)",
                                          height:
                                            "clamp(17px, 1.198vw, 1.198vw)",
                                        }}
                                      />
                                    ) : (
                                      <Image
                                        src={chatnoty}
                                        className="my-2"
                                        style={{
                                          width:
                                            "clamp(16px, 1.094vw, 1.094vw)",
                                          height:
                                            "clamp(17px, 1.198vw, 1.198vw)",
                                        }}
                                      />
                                    )}
                                  </Card.Link>
                                  <Card.Link
                                    href="#"
                                    style={{
                                      textcolors,
                                      fontSize: "clamp(12px, .729vw, .729vw)",
                                    }}
                                    // style={
                                    //   currentLoginUserId == data.userid
                                    //     ? { cursor: "default" }
                                    //     : { cursor: "pointer" }
                                    // }
                                    // style={{
                                    //   color: data.companydetails[0].primarycolor,
                                    // }}
                                    // className="chate-with"
                                    className={
                                      data?.isactive == 1
                                        ? "chate-with chatclr fw-bold mx-4"
                                        : "chate-with chatclrs fw-bold mx-4"
                                    }
                                    onClick={async (e) => {
                                      e.preventDefault();
                                      let userId = data.userid;
                                      let groupid = data.groupid;
                                      let groupicon = data.imageurl;
                                      let groupname = `${data.firstname} ${data.lastname}`;
                                      let primarycolor =
                                        data?.companydetails[0]?.primarycolor;
                                      const groupUser = [
                                        { groupmember: userId },
                                        { groupmember: userid },
                                      ];
                                      if (groupid !== null) {
                                        if (userid !== userId) {
                                          dispatch(
                                            globalChat({
                                              userId,
                                              groupid,
                                              groupicon,
                                              groupname,
                                              primarycolor,
                                            }),
                                          );
                                          // history.push("/chat");
                                          history.push(`/chat?room=${groupid}`);
                                        }
                                      } else {
                                        if (userid !== userId) {
                                          dispatch(
                                            globalChat({
                                              userId,
                                              groupid,
                                              groupicon,
                                              groupname,
                                              primarycolor,
                                            }),
                                          );
                                          const res = await dispatch(
                                            addIndividualGroups(
                                              userid,
                                              "",
                                              groupUser,
                                            ),
                                          );
                                          // history.push("/chat");
                                          history.push(
                                            `/chat?room=${res?.data?.[0]?.groupid}`,
                                          );
                                        }
                                      }
                                    }}
                                  >
                                    {t("Let's Chat")}
                                  </Card.Link>
                                </Card.Body>
                              </Card>
                            </Col>
                          </>
                        );
                      })
                  ) : (
                    <div style={{ height: "569px" }}>
                      <div className="row container mt-4">
                        <img
                          src={smaliIcon}
                          alt="smali"
                          width={35}
                          height={35}
                          className="mt-5 "
                        />
                        <h6
                          className="mt-1"
                          style={{
                            // color: `${FetchCompanyThemRes[0]?.textcolor
                            //     ? FetchCompanyThemRes[0]?.textcolor
                            //     : "#333333"
                            //     }`,
                            fontSize: "14px",
                            fontWeight: 400,
                            textAlign: "center",
                            color: "#707070",
                          }}
                        >
                          {t("Sorry.")}
                          <br /> {t("No results for your criteria.")}
                          <br />{" "}
                          {t(
                            "Try to refine your seardh or enter a new search.",
                          )}
                        </h6>
                      </div>
                    </div>
                  )}
                </Row>
              </Col>

              <Col
                lg={3}
                md={6}
                sm={12}
                xs={11}
                // className="myTaskCard myTaskCard_Grid my-5 ms-xxl-0 ms-xl-0 ms-lg-0 ms-md-3 ms-sm-3 ms-3"
                className="myTaskCard my-5 ms-xxl-0 ms-xl-0 ms-lg-0 ms-md-3 ms-sm-3 ms-3 d-none d-sm-none d-md-bloc-k"
                style={{ overflowY: "unset" }}
              >
                <div className="mx-4">
                  <p className="my-4 task_para" style={{ textcolors }}>
                    {t("My Tasks for Today")}
                  </p>
                </div>
                <div className=" right_today ">
                  <div className="task-cards-line-today">
                    {/* {fetchTodayTaskListdata?.slice(0, 7).map((task, index) => {
                        let linepercent;
                        if (
                          (task.ischecklist1count === 0) &
                          (task.totalchecklistcount === 0)
                        ) {
                          linepercent = 0;
                        } else {
                          linepercent =
                            (task.ischecklist1count / task.totalchecklistcount) *
                            100;
                        }
                        return (
                          <div
                            className="task-single-card"
                            key={index}
                          >
                            <div
                              className="task-card-color"
                              style={{
                                backgroundColor:
                                  task.priorityid ===
                                    process.env.REACT_APP_TASK_PRIORITY_HIGH
                                    ? "#FFA500"
                                    : task.priorityid ===
                                      process.env.REACT_APP_TASK_PRIORITY_EXTREME
                                      ? "red"
                                      : task.priorityid ===
                                        process.env.REACT_APP_TASK_PRIORITY_LOW
                                        ? " #FFFF00"
                                        : "#808080",
                              }}
                            ></div>
                            <div className="task-card-content">
                              {task.totalchecklistcount > 0 && (
                                <div className="task-card-progress-line">
                                  <div
                                    className="task-card-progress-line-color"
                                    style={{
                                      width: `${linepercent}%`,
                                      // backgroundColor: `${playColor}`,
                                    }}
                                  ></div>
                                </div>
                              )}
                              <div className="task-card-details-grid">
                                <div>
                                  <p className="task-card-task-name">
                                    {task.taskname}
                                  </p>
                                  <p className="task-card-sub-name">
                                    Rental Solution
                                  </p>
                                </div>
                                <div
                                  style={{
                                    textAlign: "end",
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                >
                                  {task?.assigneedetail?.length > 3 && (
                                    <div
                                      className="task-card-image"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#DEDED6",
                                        border: "none",
                                        // color: `${primaryColor}`,
                                        cursor: "pointer",
                                      }}
                                    >
                                      +{task?.assigneedetail?.length - 2}
                                    </div>
                                  )}
                                  {task?.assigneedetail?.length <= 3 &&
                                    task?.assigneedetail?.map(
                                      (assignee, i) => {
                                        return (
                                          <img
                                            className="task-card-image"
                                            src={
                                              assignee.imageurl ||
                                              AssigneeIcon
                                            }
                                          // style={{
                                          //   border: assignee.imageurl
                                          //     ? `2px ${primaryColor} solid`
                                          //     : "none",
                                          // }}
                                          />
                                        );
                                      },
                                    )}
                                  {task?.assigneedetail?.length > 3 &&
                                    task?.assigneedetail?.map(
                                      (assignee, i) => {
                                        return (
                                          i < 2 && (
                                            <img
                                              className="task-card-image"
                                              src={
                                                assignee.imageurl ||
                                                AssigneeIcon
                                              }
                                            // style={{
                                            //   border: assignee.imageurl
                                            //     ? `2px ${primaryColor} solid`
                                            //     : "none",
                                            // }}
                                            />
                                          )
                                        );
                                      },
                                    )}
                                </div>
                              </div>

                              <div
                                className="task-card-details-grid"
                                style={{ marginTop: "15px" }}
                              // key={index}
                              >
                                <div>
                                  <p className="task-card-task-name">
                                    {task.contactname}
                                  </p>
                                  <p className="task-card-sub-name">
                                    {
                                      task?.clientdetail[0]?.clientname
                                    }
                                  </p>
                                </div>
                                <div className="task-card-calendar-date">
                                  <img
                                    className="task-card-calendar"
                                    src={TaskCardCalendar}
                                  />
                                  <p className="task-card-sub-name">
                                    {moment(
                                      `${task.deadline}.000Z`,
                                    ).format("DD.MM.YYYY")}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                      )} */}

                    {/* /////////////// Map For My Task Start///////// */}

                    {/* {task?.sort((a, b) => a.statusname > b.statusname ? 1 : -1) */}
                    {task?.map((item, index) => {
                      return (
                        <>
                          <div
                            className="my_task_dimin my-3 mx-1"
                            onClick={() => {
                              setModalFunction("update");
                              setTaskid(item.taskid);
                              setShowModal(true);
                            }}
                          >
                            <div
                              className="task-card-color"
                              style={{
                                backgroundColor:
                                  item.priorityid ===
                                  process.env.REACT_APP_TASK_PRIORITY_EXTREME
                                    ? "#F76767"
                                    : item.priorityid ===
                                        process.env.REACT_APP_TASK_PRIORITY_HIGH
                                      ? "#95A7C6"
                                      : item.priorityid ===
                                          process.env
                                            .REACT_APP_TASK_PRIORITY_LOW
                                        ? "#EAEAEA"
                                        : item.priorityid ===
                                            process.env
                                              .REACT_APP_TASK_PRIORITY_NORMAL
                                          ? " #D2DCE9"
                                          : "#f8f1bc",
                              }}
                            ></div>

                            <div className="task-card-content">
                              <div className="task-card-details-grid">
                                <div className="ps-">
                                  <OverlayTrigger
                                    key={index}
                                    placement="top"
                                    id="asctooltip"
                                    // show={show}
                                    // target={target}
                                    delay={{ show: 400, hide: 500 }}
                                    overlay={
                                      <div id={`tooltip-${item.taskid}`}>
                                        <p className="ascOverlay px-1">
                                          {item.taskname.length > 8 &&
                                            item.taskname}
                                        </p>
                                      </div>
                                    }
                                  >
                                    <p className="task-card-task-name-today">
                                      {item.taskname.length > 8
                                        ? item.taskname.slice(0, 8) + "..."
                                        : item.taskname}
                                    </p>
                                  </OverlayTrigger>

                                  {/* <p className="task-card-task-name-today">
                                {item.taskname}
                                {item.taskname.length > 8 ? item.taskname.slice(0, 8) + "..." : item.taskname}
                              </p> */}

                                  <div>
                                    <p className="task-card-sub-name-today">
                                      {item?.clientdetail[0]?.clientname
                                        ? item?.clientdetail[0]?.clientname
                                        : item?.contactname
                                          ? item?.contactname
                                          : item?.clientdetail[0]?.clientname ||
                                              item?.contactname == null
                                            ? ""
                                            : ""}

                                      {/* {item?.clientdetail[ 0 ]?.clientname ? item?.clientdetail[ 0 ]?.clientname.length > 8 ? item?.clientdetail[ 0 ]?.clientname.slice(0, 8) + "..." : item?.clientdetail[ 0 ]?.clientname : item?.contactname ? item?.contactname.length > 8 ? item?.contactname.slice(0, 8) + "..." : item?.contactname : item?.clientdetail[ 0 ]?.clientname || item?.contactname == null ? "" : ""} */}
                                    </p>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    textAlign: "end",
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                >
                                  {item?.assigneedetail?.length > 3 && (
                                    <div
                                      className="task-card-image"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#00246A",
                                        border: "none",
                                        color: "#FFFFFF",
                                        cursor: "pointer",
                                      }}
                                    >
                                      +{item?.assigneedetail?.length - 3}
                                    </div>
                                  )}
                                  {item?.assigneedetail?.length <= 3 &&
                                    item?.assigneedetail?.map((assignee, i) => {
                                      return (
                                        <img
                                          alt=""
                                          key={`img-${i}`}
                                          className="task-card-image"
                                          src={
                                            assignee.imageurl || AssigneeIcon
                                          }
                                          style={{
                                            border: assignee.imageurl
                                              ? `2px ${primaryColor} solid`
                                              : "none",
                                          }}
                                        />
                                      );
                                    })}
                                  {item?.assigneedetail?.length > 3 &&
                                    item?.assigneedetail?.map((assignee, i) => {
                                      return (
                                        i < 3 && (
                                          <img
                                            alt=""
                                            key={`img-2-${i}`}
                                            className="task-card-image"
                                            src={
                                              assignee.imageurl || AssigneeIcon
                                            }
                                            style={{
                                              border: assignee.imageurl
                                                ? `2px ${primaryColor} solid`
                                                : "none",
                                            }}
                                          />
                                        )
                                      );
                                    })}
                                </div>
                              </div>
                              <div></div>
                            </div>
                          </div>
                          {/* /////////////// Map For My Task End///////// */}
                        </>
                      );
                    })}
                  </div>
                </div>
                <MyPersonalTodoTask3 />
              </Col>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Member;
